import { useZocksAuth } from '../../../components/ScopedBlock/hooks'
import { useBillingPlan } from '../../ManageTeam/useBillingPlan'
import { getUltimatePlanId } from '../../Plan/planConstants'

export const useCrossClientPlan = () => {
  const { hasScope } = useZocksAuth()
  const hasBillingCustomerReadPermission = hasScope('**', 'billing_customer:read', ['billing_customer:admin'])
  const { customer, isFetching } = useBillingPlan(!hasBillingCustomerReadPermission)

  const ultimatePlanId = getUltimatePlanId()
  // Without billing-read or a subscription the plan is unknown, so callers must not assume it is non-Ultimate.
  const isPlanKnown = !!customer?.subscription
  // A delta trial keeps the base subscription's plan id, so an active trial (started, not ended) counts as that plan.
  const hasActiveUltimateTrial = customer?.deltaTrial?.planId === ultimatePlanId && !!customer.deltaTrial.startedAt && !customer.deltaTrial.endedAt
  const isUltimate = customer?.subscription?.planId === ultimatePlanId || hasActiveUltimateTrial

  return { isFetching, isPlanKnown, isUltimate }
}
